import React from 'react';

import Button from '@mui/material/Button';
//import ExploreIcon from '@mui/icons-material/Explore';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';

import { useTranslation } from "react-i18next";

const ControlPanel = (props) => {

  const [t] = useTranslation('common');

  return (
    <React.Fragment>
      {/* <div className="control-panel">
            <h3>Options</h3>
            <div className="col text-end"> */}
      <div className="map-button">
        <Button
          variant="contained"
          onClick={props.handleToggle}
          disableElevation
          startIcon={<DirectionsBusIcon />}
          style={{ backgroundColor: "#ffa600", color: "black" }}>
          {t('map.infopanel.vehicles')}
        </Button>
      </div>
      {/* </div>
          </div> */}
    </React.Fragment >
  );

}

export default ControlPanel;